import React, {Component} from 'react'
import {Row, Col, Input} from 'reactstrap'
import {withSubscription} from '../HOC/subscription'
import gql from 'graphql-tag'
import {Query, Mutation} from 'react-apollo'
import moment from "moment/moment";
const QUERY = gql`query user($user_id: Int!, $week_commencing: String){
	user(user_id: $user_id){
    user_id
    first_name
    last_name
    project_activities(week_commencing: $week_commencing){
      user_project_activity_id
      project_activity_type{
        project_activity_type_id
        description
      }
      project{
        project_id_prefix
        project_id
        name
      }
      timesheets{
        id
        __typename
        user_project_activity_id
        timesheet_date
        user_id
        minutes_worked
        hours_worked
      }
      user_schedule{
        id
        start_date
        end_date
      }
      project_activity_budget{
        id
        description
        parent{
          stage
          address{
            full_address
        	}
        }
        address{
          full_address
        }
        comments(user_id: $user_id){
          id
          project_activity_budget_id
          note
          created_at
          user_id
          public
          user{
            first_name
            last_name
          }
        }
      }
    }
    unbillable_timesheets(week_commencing: $week_commencing){
      id
      __typename
      unbillable_type_id
      timesheet_date
      user_id
      minutes_worked
      hours_worked
      
    }
  }
}`

const MUTATION = gql`mutation upsert_user_unbillable_timesheet($user_id: Int!, $timesheet: UnbillableTimesheetInput!){
  upsert_user_unbillable_timesheet(user_id: $user_id, timesheet: $timesheet){
      id
      __typename
      unbillable_type_id
      timesheet_date
      user_id
      minutes_worked
      hours_worked
  }
}`

class UnbillableTimesheet extends Component{

    getExistingTimesheetValue = (date, unbillable_type_id, timesheets) => {
        const existingTimesheet = timesheets.find(timesheet => moment(timesheet.timesheet_date).format('YYYY-MM-DD') == date && timesheet.unbillable_type_id == unbillable_type_id)
        return (existingTimesheet) ? ((existingTimesheet.hours_worked) ? existingTimesheet.hours_worked : '') : ''
    }

    timesheetChanged = (value, date, unbillable_type_id, upsert) => {
        const timesheet_date = moment(date).format('YYYY-MM-DD')
        const timesheet = {
            timesheet_date,
            hours_worked: (value) ? value : null,
            unbillable_type_id,
            week_commencing: this.props.week_commencing
        }
        upsert({
            variables: {user_id: this.props.user_id, timesheet},
            optimisticResponse: {
                __typename: "Mutation",
                upsert_user_unbillable_timesheet: {
                    id: `${unbillable_type_id}-${timesheet_date}-6`,
                    __typename: "UnbillableTimesheet",
                    unbillable_type_id,
                    timesheet_date,
                    user_id: this.props.user_id,
                    minutes_worked: value * 60,
                    hours_worked: value
                }
            }
        }).then(console.log)
    }

    render(){
        const {data, days, timesheets, week_commencing} = this.props

        if(data && data.unbillable_types){
            return (
                data.unbillable_types
                    .filter(unbillableType => unbillableType.used_in_timesheet)
                    .map(unbillableType => {
                        return (<Row style={{
                            borderBottomColor: '#f0f3f5',
                            borderBottomStyle: 'solid',
                            borderBottomWidth: '1px',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                        }} key={unbillableType.unbillable_type_id}>
                            <Col className="col-2">
                                <small>{unbillableType.description}</small>
                            </Col>
                            {days.map((day, index) => (
                                <Col style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flex: 1,
                                    display: 'flex',
                                    paddingLeft: '5px',
                                    paddingRight: '5px',
                                }} key={index}>

                                    <Mutation
                                        mutation={MUTATION}
                                        update={(cache, { data: { upsert_user_unbillable_timesheet } }) => {

                                            const {user} = cache.readQuery({ query: QUERY, variables: {user_id: this.props.user_id, week_commencing: this.props.week_commencing} });

                                            const existingTimesheetIndex = user.unbillable_timesheets.findIndex(({id}) => id === upsert_user_unbillable_timesheet.id)

                                            let newTimesheets
                                            if(existingTimesheetIndex !== -1){
                                                newTimesheets = [
                                                    ...user.unbillable_timesheets.slice(0, existingTimesheetIndex),
                                                    {...upsert_user_unbillable_timesheet},
                                                    ...user.unbillable_timesheets.slice(existingTimesheetIndex+1)
                                                ]
                                            }
                                            else{
                                                newTimesheets = [...user.unbillable_timesheets, {...upsert_user_unbillable_timesheet}]
                                            }

                                            const newUser = {...user, unbillable_timesheets: newTimesheets}

                                            cache.writeQuery({
                                                query: QUERY,
                                                data: { user: newUser },
                                                variables: {user_id: this.props.user_id, week_commencing: this.props.week_commencing}
                                            });
                                        }}
                                    >
                                        {upsert_user_unbillable_timesheet => (
                                            <Input
                                                size="sm"
                                                type="number"
                                                value={this.getExistingTimesheetValue(day, unbillableType.unbillable_type_id, timesheets)}
                                                onChange={(e) => this.timesheetChanged(e.target.value, day, unbillableType.unbillable_type_id, upsert_user_unbillable_timesheet)}
                                            />
                                        )
                                        }
                                    </Mutation>

                                </Col>
                            ))}
                        </Row>)
                    })

            )
        }

        return <div>Loading...</div>

    }
}

export default withSubscription(UnbillableTimesheet, 'unbillable_types', 'unbillable_type_id description used_in_timesheet', 'unbillable_type_id')
